import * as ms from 'milliseconds';

export const GRID_UNIT = 8;

// The screen width at which the rail is automatically collapsed
export const RAIL_LARGE_SCREEN_THRESHOLD = 1126;

// Expanded left rail width (mirrors --rail-width in vars.css)
export const RAIL_WIDTH = 320;
// Minimum comfortable chat pane width in split views
export const MIN_CHAT_WIDTH = 385;
// Minimum card column width in split views (mirrors --narrow-width floor / 48Q)
export const CARD_COLUMN_MIN_WIDTH = 384;
// Below this viewport width an expanded rail would squish chat below MIN_CHAT_WIDTH
// in split views, so the rail is force-collapsed (and hover-expands as an overlay).
export const RAIL_AUTO_COLLAPSE_THRESHOLD = RAIL_WIDTH + MIN_CHAT_WIDTH + CARD_COLUMN_MIN_WIDTH;

// Business logic and app constants (same across all environments)
export const NUM_CHAT_MESSAGES_TO_FETCH = 25;
export const CARD_PAGINATION_SIZE = 30;
export const PRICING_LIMIT_HISTORY_DAYS = 7;
export const RECURRENCE_CARD_COUNT = 60;

export const FONT_STACK =
  '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const HEADER_HEIGHT = 64;
export const PAGE_MODAL_WIDTH = 600;
export const EXTERNAL_FORM_MAX_WIDTH = 500;
export const CREATE_MODAL_FIXED_WIDTH = 800;

// Gesture and animation thresholds
export const GESTURE_EXIT_VELOCITY = 0.2;
export const TOAST_DELAY_DURATION = ms.seconds(0.5);
export const TOAST_DEFAULT_DURATION = ms.seconds(10);
export const IS_TYPING_TIMEOUT_DURATION = ms.seconds(5);
export const IS_TYPING_UPDATE_THROTTLE_DURATION = ms.seconds(2);
export const MESSAGE_GROUPING_TIME_SPAN = ms.minutes(1);
export const WAIT_DURATION_BEFORE_PROMPTING_TO_NOTIFY_PENDING_USERS = ms.hours(24);
export const SEARCH_RESULT_NUM_CHARS_BEFORE_MATCH_TO_SHOW = 40;
export const DEFAULT_WEB_DATE_PICKER_TIME_INTERVAL_MINUTES = 15;
export const DISABLE_ANIMATIONS = false;
export const WARN_LOOPING_ANIMATIONS = false;

export const DISMOUNT_VIEW_DELAY = ms.seconds(1);
export const MARK_CARDS_VIEWED_DELAY = ms.seconds(2); // must be greater than DISMOUNT_VIEW_DELAY
export const MARK_MESSAGES_AS_READ_DELAY = ms.seconds(2); // must be greater than DISMOUNT_VIEW_DELAY

// TODO: migrate modals to `dialog` so browser manages stacking order in
// order of invocation https://app.shortcut.com/coast/story/74176/update-modal-component
export const MODAL_ZINDEX = 900;
export const MODAL_ARROWS_ZINDEX = 901;
export const IMAGE_PREVIEW_ZINDEX = 902;

export const RELATED_LOOKUP_NAME_SEPARATOR = '→';
